
interface SystemMessage {
    code: string;
    descEn: string;
    descAr: string;
}

export const systemMessages: SystemMessage[] = [
    {
        code: "add",
        descEn: "Add",
        descAr: "اضافة"
    },
    {
        code: "edit",
        descEn: "Edit",
        descAr: "تعديل"
    },
    {
        code: "delete",
        descEn: "Delete",
        descAr: "حذف"
    },
    {
        code: "save",
        descEn: "Save",
        descAr: "حفظ"
    },
    {
        code: "back",
        descEn: "Back",
        descAr: "رجوع"
    },
    {
        code: "clear",
        descEn: "Clear",
        descAr: "مسح"
    },
    {
        code: "areYouSure",
        descEn: "Are you sure ?",
        descAr: "هل انت متأكد ؟"
    },
    {
        code: "yes",
        descEn: "Yes",
        descAr: "نعم"
    },
    {
        code: "no",
        descEn: "No",
        descAr: "لا"
    },
    {
        code: "successTitle",
        descEn: "Success",
        descAr: "نجاح"
    },
    {
        code: "success",
        descEn: "Operation Completed Successfully",
        descAr: "تمت العملية بنجاح",
    },
    {
        code: "noDataFound",
        descEn: "No Data Found",
        descAr: "لا يوجد بيانات"
    },
    {
        code: "login",
        descEn: "Login",
        descAr: "دخول"
    },
    {
        code: "logout",
        descEn: "Logout",
        descAr: "تسجيل الخروج"
    },
    {
        code: "somethingWrong",
        descEn: "Something Wrong !",
        descAr: "حدث خطأ ما"
    },
    {
        code: "error",
        descEn: "Error",
        descAr: "خطأ"
    },
    {
        code: "home",
        descEn: "Home",
        descAr: "الرئيسية"
    },
    {
        code: "true",
        descEn: "Yes",
        descAr: "نعم"
    },
    {
        code: "false",
        descEn: "No",
        descAr: "لا"
    },
    {
        code: "status",
        descEn: "Status",
        descAr: "الحالة"
    },
    {
        code: "unauthorized",
        descEn: "Unauthorized User",
        descAr: "المستخدم غير مخول للدخول"
    },
    {
        code: "tokenExpired",
        descEn: "Login time expired, please login again",
        descAr: "انتهت صلاحية الدخول , يرجى الدخول مرة اخرى"
    },

    {
        code: "fieldRequired",
        descEn: "Field Required",
        descAr: "الحقل مطلوب"
    },

    {
        code: "user",
        descEn: "User",
        descAr: "المستخدم"
    },
    {
        code: "username",
        descEn: "Username",
        descAr: "اسم المستخدم"
    },
    {
        code: "password",
        descEn: "Password",
        descAr: "كلمة المرور"
    },
    {
        code: "generalError",
        descEn: "Internal Server Error",
        descAr: "حدث خطأ في النظام"
    },

    {
        code: "userNotFound",
        descEn: "User not found",
        descAr: "المستخدم غير موجود"
    },

    {
        code: "invalidLogin",
        descEn: "Please check your login information",
        descAr: "يرجى التأكد من معلومات الدخول"
    },
    {
        code: "welcome",
        descEn: "Welcome",
        descAr: "أهلا",
    }
]



